import __request__ from "routing/request";
export function getRelevant() {
  return __request__("GET", "/system/configuration", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getRelevantByName(name) {
  return __request__("GET", `/system/configuration/${name}`, null, {}, {
    "Accept": ["application/json"]
  });
}
